import MineDamageLogic from "../../../logic/MineDamageLogic";
import BigNum from "../../math/BigNum";
import BigNumValue from "../../value/BigNumValue";
import FreeUpgrade from "./FreeUpgrade";
import UpgradeCreator from "./UpgradeCreator";

export default class MinedUpgrade extends FreeUpgrade {
    /**
     * @param {UpgradeCreator} upgradeCreator 
     * @param {string} title
     * @param {string} iconFileName
     * @param {BigNum} valueDelta
     * @param {BigNumValue} upgradeBonusValue External value holder for upgrade bonus.
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(upgradeCreator, title, iconFileName, valueDelta, upgradeBonusValue, mineDamageLogic) {
        super(upgradeCreator, title, iconFileName);

        /**
         * @constant
         * @type {BigNum}
         */
        this.valueDelta = valueDelta;
        /**
         * @constant
         * @type {BigNumValue}
         */
        this.upgradeBonusValue = upgradeBonusValue;

        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;
    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @override
     */
    onUpgradePurchased() {
        this.upgradeBonusValue.incrementValue(this.valueDelta);

        if (this.mineDamageLogic) {
            this.mineDamageLogic.calculateTotalMineDamagePerTurn();
        }
    }

    /**
     * @override
     * @returns {boolean}
     */
    isCombineSupported() {
        return true;
    }

}